var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/atoms/image.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["config", "data"], 
["loading_fallback"], 
function (l_config, l_data, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("config", l_config);
frame.set("data", l_data);
frame.set("loading_fallback", Object.prototype.hasOwnProperty.call(kwargs, "loading_fallback") ? kwargs["loading_fallback"] : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");var t_2 = "";if(env.getTest("defined").call(context, l_config) === true && env.getFilter("default").call(context, runtime.memberLookup((l_config),"image_rounded"))) {
var t_3;
t_3 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "classes"),["image--rounded"]);
frame.set("classes", t_3, true);
if(frame.topLevel) {
context.setVariable("classes", t_3);
}
if(frame.topLevel) {
context.addExport("classes", t_3);
}
;
}
t_2 += "<img";
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"classes")) === true) {
t_2 += " class=\"";
t_2 += runtime.suppressValue(env.getFilter("join").call(context, runtime.memberLookup((l_config),"classes")," "), env.opts.autoescape);
t_2 += "\" ";
;
}
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"alt")) === true) {
t_2 += " alt=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_config),"alt"), env.opts.autoescape);
t_2 += "\" ";
;
}
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"src")) === true) {
t_2 += " src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_config),"src"), env.opts.autoescape);
t_2 += "\" ";
;
}
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"loading")) === true) {
t_2 += " loading=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_config),"loading"), env.opts.autoescape);
t_2 += "\" ";
;
}
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"width")) === true) {
t_2 += " width=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_config),"width"), env.opts.autoescape);
t_2 += "\" ";
;
}
if(env.getTest("defined").call(context, l_config) === true && env.getTest("defined").call(context, runtime.memberLookup((l_config),"height")) === true) {
t_2 += " height=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_config),"height"), env.opts.autoescape);
t_2 += "\" ";
;
}
frame = frame.push();
var t_6 = env.getFilter("default").call(context, l_data);
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0];
frame.set("[object Object]", t_6[t_4][0]);
var t_8 = t_6[t_4][1];
frame.set("[object Object]", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
t_2 += runtime.suppressValue(t_7, env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(t_8, env.opts.autoescape);
t_2 += "\"";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_9 in t_6) {
t_4++;
var t_10 = t_6[t_9];
frame.set("name", t_9);
frame.set("value", t_10);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
t_2 += runtime.suppressValue(t_9, env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(t_10, env.opts.autoescape);
t_2 += "\"";
;
}
}
}
frame = frame.pop();
t_2 += "\n    />\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/atoms/image.html.njk"] , dependencies)